import { ListItemButtonProps } from '@mui/material';
import { AvatarIcon, BankIcon, BrightyListItem, CoinIcon, LogoIcon } from '../..';
import { useTranslation } from 'react-i18next';

export function InternalTransferListItem(props: ListItemButtonProps) {
  const { t } = useTranslation();

  return (
    <BrightyListItem
      icon={<AvatarIcon icon={<LogoIcon />} color="info" />}
      title={t('{{companyName}} transfer')}
      subtitle={t('Send fiat or crypto using {{companyName}} username or phone number')}
      {...props}
    />
  );
}

export function BankTransferListItem(props: ListItemButtonProps) {
  const { t } = useTranslation();

  return (
    <BrightyListItem
      icon={<AvatarIcon icon={<BankIcon />} color="info" />}
      title={t('Bank transfer')}
      subtitle={t('Send from {{companyName}} to another bank, use IBAN and bank details')}
      {...props}
    />
  );
}

export function CryptoTransferListItem(props: ListItemButtonProps) {
  const { t } = useTranslation();

  return (
    <BrightyListItem
      icon={<AvatarIcon icon={<CoinIcon />} color="info" />}
      title={t('Crypto transfer')}
      subtitle={t('Send cryptocurrencies from {{companyName}} to external wallets')}
      {...props}
    />
  );
}
